const mock1 = {
  cardText1:
    'Воздушные фильтры очищают воздух, поступающий в двигатель, от частиц пыли и других загрязнений. Чистый воздух улучшает качество процесса сгорания топлива и обеспечивает оптимальную производительность двигателя. Воздушные фильтры особенно важны в условиях запылённых дорог или в городах с высоким уровнем загрязнения воздуха. Замена воздушного фильтра, в зависимости от условий эксплуатации, рекомендуется каждые 15 000–30 000 км, чтобы избежать дополнительного расхода топлива и поддерживать эффективность работы двигателя.',
  cardText2:
    'Воздушные фильтры очищают воздух, поступающий в двигатель, от частиц пыли и других загрязнений. Чистый воздух улучшает качество процесса сгорания топлива и обеспечивает оптимальную производительность двигателя. Воздушные фильтры особенно важны в условиях запылённых дорог или в городах с высоким уровнем загрязнения воздуха. Замена воздушного фильтра, в зависимости от условий эксплуатации, рекомендуется каждые 15 000–30 000 км, чтобы избежать дополнительного расхода топлива и поддерживать эффективность работы двигателя.',
  image1: '/images/carFiltersPage/air-filter.webp',
  image2: '/images/carFiltersPage/fuel-filter.webp',
  list: [
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
  ],
};

const mock2 = {
  cardText1: 'oilfilter',
  cardText2: 'oilfilter',
  image1: '/images/carFiltersPage/air-filter.webp',
  image2: '/images/carFiltersPage/fuel-filter.webp',
  list: [
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
  ],
};

const mock3 = {
  cardText1: 'fuelfilter',
  cardText2: 'fuelfilter',
  image1: '/images/carFiltersPage/air-filter.webp',
  image2: '/images/carFiltersPage/fuel-filter.webp',
  list: [
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
  ],
};

const mock4 = {
  cardText1: 'cabinfilter',
  cardText2: 'cabinfilter',
  image1: '/images/carFiltersPage/air-filter.webp',
  image2: '/images/carFiltersPage/fuel-filter.webp',
  list: [
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
  ],
};

const mock5 = {
  cardText1: 'transmissionfilter',
  cardText2: 'transmissionfilter',
  image1: '/images/carFiltersPage/air-filter.webp',
  image2: '/images/carFiltersPage/fuel-filter.webp',
  list: [
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
    'Воздушные фильтры очищают воздух',
  ],
};

const mockData = {
  airfilter: mock1,
  oilfilter: mock2,
  fuelfilter: mock3,
  cabinfilter: mock4,
  transmissionfilter: mock5,
};

export const data = (activeButton) => {
  return mockData[activeButton] || [];
};
